var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.372 14.668c.22 2.058 1.876 3.714 3.933 3.943 1.528.17 3.096.316 4.696.316s3.168-.146 4.696-.316c2.057-.23 3.712-1.885 3.933-3.943.162-1.52.3-3.079.3-4.67s-.138-3.15-.3-4.668c-.22-2.059-1.876-3.714-3.933-3.943-1.528-.17-3.097-.317-4.696-.317-1.6 0-3.168.147-4.696.317-2.057.23-3.713 1.884-3.933 3.943-.162 1.519-.3 3.079-.3 4.669s.138 3.15.3 4.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m14.697 18.61-.11-.993zm-9.392 0 .11-.993zM10 17.928c-1.542 0-3.066-.14-4.586-.31l-.221 1.988c1.536.171 3.15.322 4.807.322zm4.585-.31c-1.52.17-3.043.31-4.585.31v2c1.657 0 3.27-.151 4.807-.322zm5.038-2.842c.164-1.53.305-3.132.305-4.776h-2c0 1.536-.132 3.053-.294 4.563zm.305-4.776c0-1.645-.141-3.247-.305-4.776l-1.989.213c.162 1.51.294 3.027.294 4.563zM10.001 2.07c1.542 0 3.066.141 4.585.31l.222-1.987C13.27.222 11.658.07 10 .07zm-4.586.31c1.52-.169 3.044-.31 4.586-.31v-2c-1.657 0-3.27.152-4.807.323zM.378 5.224C.214 6.753.072 8.354.072 10h2c0-1.536.133-3.053.294-4.563zM.072 10c0 1.644.142 3.247.306 4.776l1.988-.213c-.161-1.51-.294-3.027-.294-4.563zm19.552-4.776c-.27-2.527-2.295-4.549-4.816-4.83l-.222 1.988a3.474 3.474 0 0 1 3.05 3.055zm-4.816 14.382c2.52-.281 4.546-2.304 4.816-4.83l-1.989-.213a3.474 3.474 0 0 1-3.049 3.055zM5.194.393C2.673.674.648 2.696.378 5.223l1.988.213a3.474 3.474 0 0 1 3.05-3.055zm.221 17.224a3.474 3.474 0 0 1-3.049-3.055l-1.988.213c.27 2.526 2.295 4.549 4.816 4.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.066 9.734h1.836l1.645-3.466 2.359 7.459 2.193-3.993h1.836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLine);
export default __webpack_public_path__ + "static/media/heart-line.ba55ddd92fa5bb096a2793d235138c58.svg";
export { ForwardRef as ReactComponent };